import React from 'react';
import { Table } from 'antd';

const StandardTable = (props) => {
    const {columns, data, loading } = props;
    return <Table columns={columns} dataSource={data} loading={loading} />;
};

export default StandardTable;



// WEBPACK FOOTER //
// ./src/components/StandardTable/index.js